function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 15.9999H4.75C1.75 15.9999 1 15.2856 1 12.4285V10.9999C1 8.14275 1.75 7.42847 4.75 7.42847H12.25C15.25 7.42847 16 8.14275 16 10.9999V12.4285C16 15.2856 15.25 15.9999 12.25 15.9999Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.21436 7.42857V5.82143C4.21436 3.16161 4.92864 1 8.50007 1C11.7144 1 12.7858 2.60714 12.7858 5.01786",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 13.8572C9.6835 13.8572 10.6429 12.8979 10.6429 11.7144C10.6429 10.5309 9.6835 9.57153 8.50004 9.57153C7.31657 9.57153 6.35718 10.5309 6.35718 11.7144C6.35718 12.8979 7.31657 13.8572 8.50004 13.8572Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.1e5a22d0f324c6f7be5d1565e861bb72.svg";
export { ForwardRef as ReactComponent };